(ns hai.notes.header
  "The tinted header row every notes surface shares: note icon + title (a
   link when `:href` is given) with action buttons on the right. `:dotted?`
   adds the perforated bottom edge. Actions come as children — hosts wrap
   their own `:button.bar-action-btn`s in tooltips as needed."
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private back-icon (icons/mui-icon :outlined :arrow_back))

(o/defstyled bar :div
  {:display "flex" :align-items "center" :gap "10px"
   :padding "14px 18px"
   :background t/--notes
   :color t/--note-kraft}
  [:&.dotted
   {:border-bottom-width "2px"
    :border-bottom-style "dotted"
    :border-bottom-color t/--note-sage-35}]
  [:.bar-icon
   {:display "inline-flex" :align-items "center"
    :color t/--note-kraft}
   ;; Stroke icon — undo the page's `svg {fill: currentColor}`.
   [:svg {:fill "none"}]]
  [:.bar-title
   {:font-size "16px" :font-weight "700" :line-height "1.2"
    :margin "0"
    :letter-spacing "-0.005em"
    :color t/--note-kraft}]
  [:.bar-title-link
   {:display "inline-flex" :align-items "center" :gap "10px"
    :color "inherit"
    :text-decoration "none"
    :cursor "pointer"}
   [:&:hover
    [:.bar-title {:text-decoration "underline" :text-underline-offset "3px"}]]]
  ;; Auto margins on both the back button and the actions block split the free
  ;; space, centering the arrow between title and actions — so the title stays
  ;; put when the arrow appears.
  [:.bar-back
   {:margin-left "auto"}]
  [:.bar-actions
   {:margin-left "auto"
    :display "flex" :align-items "center" :gap "6px"}]
  [:.bar-action-btn
   {:width "28px" :height "28px"
    :border "none" :border-radius "999px"
    :background "transparent"
    :padding "0"
    :color t/--note-kraft
    :cursor "pointer"
    :display "inline-flex" :align-items "center" :justify-content "center"
    :transition "background 0.15s ease"}
   [:&:hover {:background t/--note-kraft-10}]
   [:svg {:fill "currentColor"}]]
  ([{:keys [title href target rel dotted? on-back]} & actions]
   ;; Keep the root fragment's first child a concrete element (never a bare
   ;; `[:<>]`): Ornament's fragment-flattening recurses into a leading `:<>`
   ;; child and drops its siblings, which would silently swallow the back
   ;; button and the whole `.bar-actions` group (the ⋮ and ✕).
   (into
    [:<> {:class (when dotted? "dotted")}]
    (concat
     (if href
       [[:a.bar-title-link {:href href :target target :rel rel}
         [:span.bar-icon [icons/note {:size 18}]]
         [:h2.bar-title title]]]
       [[:span.bar-icon [icons/note {:size 18}]]
        [:h2.bar-title title]])
     (when on-back
       [[:button.bar-action-btn.bar-back
         {:type "button"
          :aria-label "Back"
          :on-click on-back}
         [back-icon]]])
     [(into [:div.bar-actions] actions)]))))
